import { getContextValueBySku } from '../../bh-list-context/utils/bh-tracking-context'

export const cartItemsToGTMProducts = ({
	gtmEvent,
	items = [],
	config: {
		catalog: {
			products: {
				attributesMapping: { brand: brandAttributeCode },
			},
		},
	},
	getLocalStorageByGroup,
}) => {
	return items.map((item, i) => ({
		id: item.parentSku ?? item.sku,
		position: i + 1,
		name: item.name,
		price: item.totals?.price ?? undefined,
		quantity: item.qty,
		category: item.productData?.attributes?.category_level_1?.value ?? undefined,
		brand: item.productData?.attributes?.[brandAttributeCode]?.value ?? undefined,
		dimension20: item.sku,
		list:
			getContextValueBySku({
				sku: item.parentSku ?? item.sku,
				enablePageId: false,
				getLocalStorageByGroup,
			}) ??
			gtmEvent ??
			undefined,
	}))
}
